import { Route, Routes } from "react-router-dom";
import Decryption from "./Decryption";
const RenderRoutes = ({
  routes = [
    {
      path: "/",
      element: () => <></>,
    },
  ],
}) => (
  <Routes>
    {routes.map((route, routeIdx) => (
      <Route
        path={route.path}
        key={routeIdx}
        element={<Decryption route={route} />}
      />
    ))}
  </Routes>
);
export default RenderRoutes;
